import * as React from 'react';
import { Component } from 'react';
import { Image } from './Image';
import { Grid, Row, Col } from '../bootstrap-components/BootstrapComponents';

class Footer extends Component<{}, {}> {
    render() {
        return (
            <footer>
                <Grid>
                    <Row>                        
                        <Col smOffset={1} xs={2} className='vcenter footer-image-container'>
                            <a href='http://www.nvhus.dk'>
                                <Image source='logos/logo 1.png' alt='Footer logo'className={'footer-image'} />
                            </a>
                        </Col>
                        <Col xs={2} className='vcenter footer-image-container' >
                            <Image source='logos/logo-novonordiskfonden.png' alt='Footer logo' className={'footer-image'} />
                        </Col>
                        <Col sm={2} xs={3} className='vcenter footer-image-container'>
                            <Image source='logos/logo-villumfonden.png' alt='Footer logo' className={'footer-image'} />
                        </Col>
                        <Col sm={2} xs={3} className='vcenter footer-image-container'>
                            <Image source='logos/logo-undervisningsministeriet.png' alt='Footer logo' className={'footer-image'} />
                        </Col>
                        <Col xs={2} className='vcenter footer-image-container'>
                            <Image source='logos/logo-grundfos.png' alt='Footer logo' className={'footer-image'} />
                        </Col>                       
                    </Row>
                </Grid>
            </footer>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/Footer.tsx